export enum SwapQualityIssueAction {
    Record = 1,
    NoIssue = 2,
    View = 3,
    Reopen = 4
}